export const SHOW_OTP_FORGOT_MODAL = 'SHOW_OTP_FORGOT_MODAL';
export const SHOW_OTP_LOGIN_MODAL = 'SHOW_OTP_LOGIN_MODAL';
export const SHOW_OTP_GG_AUTHEN = 'SHOW_OTP_GG_AUTHEN';
export const GET_MESSAGE_OTP = 'GET_MESSAGE_OTP';
export const CLEAR_MESSAGE_OTP = 'CLEAR_MESSAGE_OTP';
export const CLOSE_OTP_MODAL = 'CLOSE_OTP_MODAL';
export const GO_TO_NEXT_STEP = 'GO_TO_NEXT_STEP';
export const SHOW_CONFIRM_PASSWORD_MODAL = 'SHOW_CONFIRM_PASSWORD_MODAL';
export const SHOW_MERCHANT_CONFIRM_PASSWORD_MODAL =
  'SHOW_MERCHANT_CONFIRM_PASSWORD_MODAL';
export const SHOW_EMPLOYEE_CONFIRM_PASSWORD_MODAL =
  'SHOW_EMPLOYEE_CONFIRM_PASSWORD_MODAL';
export const MERCHANT_STATUS_CHANGE = 'MERCHANT_STATUS_CHANGE';
export const GET_MESSAGE = 'GET_MESSAGE';
export const CLEAR_MESSAGE = 'CLEAR_MESSAGE';
export const CLOSE_CONFIRM_PASSWORD_MODAL = 'CLOSE_CONFIRM_PASSWORD_MODAL';
export const SHOW_OTP_SIGN_UP_MODAL = 'SHOW_OTP_SIGN_UP_MODAL';
export const NEXT_STEP_1 = 'NEXT_STEP_1';
export const NEXT_STEP_2 = 'NEXT_STEP_2';
export const NEXT_STEP_3 = 'NEXT_STEP_3';
export const NEXT_STEP_4 = 'NEXT_STEP_4';
export const FINAL_STEP = 'FINAL_STEP';
export const OPEN_LOADING_API = 'OPEN_LOADING_API';
export const CLOSE_LOADING_API = 'CLOSE_LOADING_API';
export const SIGN_UP_SUCCESS = 'SIGN_UP_SUCCESS';
export const DROP_IMAGE = 'DROP_IMAGE';
export const SET_MODE = 'SET_MODE';
export const MENU_OPEN = 'MENU_OPEN';
export const SET_MENU = 'SET_MENU';
export const REDIRECT_FROM_MODAL = 'REDIRECT_FROM_MODAL';
export const UN_REDIRECT_FROM_MODAL = 'UN_REDIRECT_FROM_MODAL';
